import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handle(event) {
    this.element.requestSubmit();
  }
}
